import FirebaseContext, { withFirebase } from './context';
import * as collections from './collections';
import * as storageRefs from './storage';
import Firebase from './Firebase';

export default Firebase;

export { FirebaseContext, withFirebase, collections, storageRefs };
